import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type DetailsSurveyModalStore } from '../../store/detailsSurveyModalStore'
import { ActionsList } from './ActionsList'
import styles from './styles.module.scss'

export const ActionsTab = observer(({ store }: { store: DetailsSurveyModalStore }) => {
  const {
    successActions,
    successActionGroups,
    isSuccessActionPerGroup,
    fallbackActions,
    getFutureActionsTags,
  } = store

  return (
    <div className={styles.tabContent}>
      <div className={styles.section}>
        <Typography ariaLabel={'successAction'} variant={'body-rg-medium'} className={styles.head}>
          Success
        </Typography>

        {isSuccessActionPerGroup ? (
          successActionGroups.map((group) => (
            <div key={group.key} className={styles.group}>
              <Typography
                ariaLabel={'successActionGroup'}
                variant={'body-md-medium'}
                className={styles.subHead}
              >
                {group.label}
              </Typography>
              <ActionsList actions={group.actions} getFutureActionsTags={getFutureActionsTags} />
            </div>
          ))
        ) : (
          <ActionsList actions={successActions} getFutureActionsTags={getFutureActionsTags} />
        )}
      </div>

      <div className={styles.section}>
        <Typography ariaLabel={'fallbackAction'} variant={'body-rg-medium'} className={styles.head}>
          Fallback
        </Typography>

        <ActionsList actions={fallbackActions} getFutureActionsTags={getFutureActionsTags} />
      </div>
    </div>
  )
})
